export type APIErrorCode =
  | "bad_request"
  | "unauthorized"
  | "forbidden"
  | "not_found"
  | "method_not_allowed"
  | "conflict"
  | "gone"
  | "validation_error"
  | "rate_limited"
  | "internal_error"
  | "unsupported_media_type"
  | "not_implemented"
  | "checksum_mismatch"
  | "missing_parameter"
  | "invalid_parameter"
  | "token_expired"
  | "token_blacklisted"
  | "insufficient_access"
  | "upload_failed"
  | "download_failed"
  | "resource_unavailable";

export interface APIError {
  status: number;
  code: APIErrorCode;
  message: string;
  traceId?: string;
}

export function isAPIError(data: unknown): data is APIError {
  return (
    typeof data === "object" &&
    data !== null &&
    "status" in data &&
    "code" in data &&
    "message" in data
  );
}

export function getAPIErrorMessage(error: unknown, fallback = "Something went wrong. Please try again."): string {
  if (typeof error === "object" && error !== null && "response" in error) {
    const axiosError = error as { response?: { data?: unknown } };
    if (axiosError.response?.data && isAPIError(axiosError.response.data)) {
      return axiosError.response.data.message;
    }
  }
  return fallback;
}

export function getAPIErrorCode(error: unknown): APIErrorCode | null {
  if (typeof error === "object" && error !== null && "response" in error) {
    const axiosError = error as { response?: { data?: unknown } };
    if (axiosError.response?.data && isAPIError(axiosError.response.data)) {
      return axiosError.response.data.code;
    }
  }
  return null;
}
